import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEraser: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="eraser, rubber, clean-up"><path d="M14.5 2.5L2.5 14.5L8.25 20.25H11L21.5 9.5L14.5 2.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7 11L13.5 17.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconEraser;
